import React, { useContext } from 'react';
import { BaseEdge, EdgeLabelRenderer, useReactFlow } from '@xyflow/react';
import { StateContext } from '../../StateContainer';

const SelfConnectingEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  markerEnd,
}) => {
  const { setDettagliNodi } = useContext(StateContext);
  const { setEdges } = useReactFlow();

  const offsetX = 40; // quanto si allarga il loop in orizzontale
  const offsetY = 100; // quanto si alza il loop verticalmente

  const edgePath = `
    M ${sourceX} ${sourceY}
    C ${sourceX + offsetX} ${sourceY - offsetY},
      ${targetX - offsetX} ${targetY - offsetY},
      ${targetX} ${targetY}
  `;

  const labelX = (sourceX + targetX) / 2;
  const labelY = (sourceY + targetY) / 2 - offsetY / 2 - 25;

  const onEdgeClick = () => {
    setEdges((edges) => edges.filter((edge) => edge.id !== id));

    setDettagliNodi((prevNodi) => {
      const updatedNodi = { ...prevNodi };

      Object.keys(updatedNodi).forEach((nodoKey) => {
        if (updatedNodi[nodoKey].intents) {
          updatedNodi[nodoKey].intents = updatedNodi[nodoKey].intents.filter(
            (intent) => intent.id !== id
          );
        }
      });

      return updatedNodi;
    });
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          className="button-edge__label nodrag nopan"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          }}
        >
          <button className="button-edge__button" onClick={onEdgeClick}>
            ×
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default SelfConnectingEdge;
